import {MedicationV2, MedicationVariation} from "../medication-widget/types";
import {MedicationPrice} from "../../../state/types/MedicationWidget";

export const findLeastStrengthDrugId = (drugIDToVariations: Record<string, MedicationVariation>): string => {
    return Object.keys(drugIDToVariations)
        .sort((key1, key2) =>
            parseFloat(drugIDToVariations[key1].strength.split("mg")[0]) - parseFloat(drugIDToVariations[key2].strength.split("mg")[0]))[0];
}

/*
This method extracts the available options indexes from a Medication Variation as a 2D array, each dimension represents the unique available index number(s).
e.g. Drug1 has 2 options and options' dimension indexes are [1,0] and [1,1] respectively, the result output is [[1],[0,1]], sorting order not guaranteed.
 */
export const extractMedicationVariationAvailableOptionIndexes = (medicationVariation: MedicationVariation): Set<number>[] => {
    const resultMap = new Map<number, Set<number>>();
    medicationVariation.options
        .map(option => option.dimensionIndex)
        .forEach(dimensionIndex => {
            dimensionIndex.forEach((value, index) => {
                const currentSet = resultMap.get(index) ?? resultMap.set(index, new Set()).get(index);
                currentSet!.add(value);
            });
        })
    return Array.from(resultMap.values());
}

export const findCurrentSelectionPrices = (medication: MedicationV2, drugId: string, selectedQuantityIndex: number, selectedSupplyIndex: number) => {
    const currentDrugVariations = medication.drugIDToVariations[drugId];
    return currentDrugVariations.options
        .find(option => option.dimensionIndex.toString() === [selectedQuantityIndex, selectedSupplyIndex].toString());
}

export const generateMedicationDropdownText = (medication: MedicationV2) => {
    return medication.medicationInfo.heading + ' (' + medication.medicationInfo.subHeading + ')';
}

export const removeWordSupplyInStringIfAny = (input: string) => {
    return input.replaceAll("supply", "");
}

export const generateSaveWithPrimePriceString = (currentMedicationPrice: MedicationPrice) => {
    const savingWithPrice = currentMedicationPrice.totalRetailPrice.amount - currentMedicationPrice.totalPrimePrice.amount;
    return `Save ${currentMedicationPrice.totalRetailPrice.currencySymbol}${savingWithPrice.toFixed(2)} with Prime`;
}